"use client";
import React from "react";
import StartTrialBtn from "../StartTrialBtnProducts";
import IndustryComponent from "@/component/Education/IndustryComponent";
import WhatWeBanner1 from "@/component/Education/WhatweBanner";
import Image from "next/image";
import discoveryGoalSettingIco from "@/Helper/images/discovery_goal_setting.svg";
import DataIntegrationPreparationIco from "@/Helper/images/data_integration_preparation.svg";
import InsightGenerationPredictiveModeling from "@/Helper/images/insight_generation_predictive_modeling.svg";
import ActionableImplementationTrainingIco from "@/Helper/images/actionable_implementation_training.svg";
import ContinuousSupportImprovementIco from "@/Helper/images/continuous_support_improvement.svg";

const Education = () => {
  return (
    <>
      <section className="banner_bg1 education_indusbg">
        <div className="container banner_container1">
          <div className="banner_inner">
            <div className="banner_left">
              <h1 className="banner_heading1">
                Empowering education with data-driven insights
              </h1>
              <p className="banner_text1">
                We deliver tailored analytics solutions that help schools, universities, and educational institutions make data-driven decisions for a more impactful learning experience.
              </p>
              <div className="banner_btn_container">
                <StartTrialBtn Text={"Get Started Today"} />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about_topsect">
        <div className="container">
          <div className="about_topsectinner">
            <div className="common_titbox">
              <h2 className="common_hd">What we offer</h2>
              <p className="common_desc">
                Our solutions focus on key areas of educational improvement, enabling institutions to address
                critical needs, improve engagement, and ensure success. Here’s how we support the education sector
              </p>
            </div>
          </div>
        </div>
      </section>
      <WhatWeBanner1 />

      <section className="comm_indusreiessection Casestudies_indusreies">
        <div className="container">
          <div className="common_titbox common_titboxcenter">
            <h2 className="common_hd">Case studies</h2>
            <p className="common_desc">
              We have successfully partnered with educational institutions to achieve measurable improvements. <br />
              Here are a few examples of our impact in education
            </p>
          </div>
          <div className="indus_inner">
            <div className="indus_list_case">
              <h2 className="indus_hd1">
                Enhancing resource efficiency
              </h2>
              <p className="indus_desc1">
                By analyzing resource allocation and utilization data, we helped the institution reallocate budget, reducing overhead by 15% and freeing up funds for new academic programs.
              </p>
            </div>
            <div className="indus_list_case">
              <h2 className="indus_hd1">
                Increasing Parental Engagement by 25% for a School
              </h2>
              <p className="indus_desc1">
                Our parental engagement insights enabled this network to improve communication and involvement, resulting in a 25% increase in parental participation in school activities and decision-making.
              </p>
            </div>

          </div>
        </div>
      </section>
      {/* <section className="comm_indusreiessection">
        <div className="container">
          <div className="common_titbox common_titboxcenter">
            <h2 className="common_hd">Why choose iKnot?</h2>
          </div>
          <div className="indus_chooseinner">

            <div className="indus_chooselist indus_chooselist1">
              <h3 className="indus_hd1">Education expertise</h3>
              <p className="indus_desc1">
                With extensive experience in the education sector, we understand the challenges and priorities of institutions and offer analytics solutions that are designed to improve student outcomes and operational efficiency.
              </p>
            </div>
            <div className="indus_chooselist indus_chooselist2">
              <h3 className="indus_hd1">Proven impact on student success</h3>
              <p className="indus_desc1">
                Our analytics solutions are designed to deliver real results, from boosting engagement to reducing dropout rates, improving resource allocation, and enhancing communication with parents.
              </p>
            </div>
            <div className="indus_chooselist indus_chooselist3">
              <h3 className="indus_hd1">Comprehensive, end-to-end service</h3>
              <p className="indus_desc1">
                We handle every stage of the analytics journey—from data integration and insight generation to implementation and ongoing support—providing an all-encompassing solution for educational analytics.
              </p>
            </div>
            <div className="indus_chooselist indus_chooselist4">
              <h3 className="indus_hd1">Data security & compliance</h3>
              <p className="indus_desc1">
                We understand the importance of data security and compliance in education. Our solutions prioritize data privacy, safeguarding student and institutional information while meeting regulatory requirements.
              </p>
            </div>
            <div className="indus_chooselist indus_chooselist5">
              <h3 className="indus_hd1">Scalable solutions for all education levels</h3>
              <p className="indus_desc1">
                Our solutions are adaptable for K-12 schools, higher education institutions, and other educational organizations, providing scalable analytics that grow with your needs.
              </p>
            </div>
          </div>
        </div>
      </section> */}
     
      <section className="why_hireapp">
        <div className="container">
          <div className="why_hireappinner">
            <div className="why_hireleft">
              <div className="common_titbox">
                <h2 className="common_hd">Our Approach</h2>
                <p className="common_desc">Our data-driven approach to education is designed to help institutions make better,
                  faster decisions that benefit students and staff alike:</p>
              </div>
            </div>
            <div className="why_hirergt">
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={discoveryGoalSettingIco}
                    alt="Discovery & Goal Setting"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Discovery & Goal Setting</h3>
                  <p className="bx_rightdesc">We start by understanding your institution’s unique challenges, objectives, and data landscape. This process allows us to develop a tailored solution roadmap that meets your specific needs.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={DataIntegrationPreparationIco}
                    alt="Data Integration & Preparation"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Data Integration & Preparation</h3>
                  <p className="bx_rightdesc">Education data often exists in silos. We integrate data from multiple sources—student records, learning management systems, attendance, and more—to create a unified view, ensuring data accuracy and consistency.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={InsightGenerationPredictiveModeling}
                    alt="Insight Generation & Predictive Modeling"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Insight Generation & Predictive Modeling</h3>
                  <p className="bx_rightdesc">Through advanced analytics, AI, and machine learning, we turn raw data into actionable insights. From identifying at-risk students to predicting enrolment trends, our models empower you to make proactive decisions.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={ActionableImplementationTrainingIco}
                    alt="Actionable Implementation & Training"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Actionable Implementation & Training</h3>
                  <p className="bx_rightdesc">We work closely with your team to implement our solutions into daily operations, providing training to ensure educators, administrators, and support staff can leverage analytics effectively.</p>
                </div>
              </div>
              <div className="why_hirergtlist">
                <div className="icons_bx">
                  <Image
                    src={ContinuousSupportImprovementIco}
                    alt="Continuous Support & Improvement"
                  />
                </div>
                <div className="bxright_cont">
                  <h3 className="bx_righthd">Continuous Support & Improvement</h3>
                  <p className="bx_rightdesc">Education is a constantly evolving field, and so are our solutions. We provide ongoing support and improvements to ensure your analytics remain relevant and impactful, adapting to new challenges and opportunities.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="industry_bg1">
        <div className="container industry_containerouter1">
          <div className="common_titbox common_titboxcenter"><h2 className="common_hd">Why Choose iKnot?</h2>
          </div>
          <IndustryComponent />
        </div>
      </section>
      <section className="cta_outer education_cta_outer">
        <div className="container cta_container">
          <div className="cta_inner">
            <div className="cta_innerout1">
              <div className="cta_left1">
                <h3 className="cta_hd">
                  Ready to elevate your educational institution with data analytics?
                </h3>
                <p className="cta_desc">
                  Get in touch with our experts to learn how our solutions can help you optimize student success, resource allocation, and overall institutional effectiveness.
                </p>
                <div className="banner_btn_container">
                  <StartTrialBtn Text={"Get Started"} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Education;
